import { IColumns } from '../../../../components/Table'

export type WalletsColumnKeys = 'id' | 'currency' | 'address' | 'addressSuffix' | 'addressProtocol' | 'actions'

export const columns: IColumns<WalletsColumnKeys>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'currency',
    label: 'CURRENCY',
  },
  {
    id: 'address',
    label: 'ADDRESS',
  },
]
export const modalColumns: IColumns<WalletsColumnKeys>[] = [
  {
    id: 'currency',
    label: 'CURRENCY',
  },
  {
    id: 'address',
    label: 'ADDRESS',
  },
  {
    id: 'addressProtocol',
    label: 'ADDRESS PROTOCOL',
  },
]
